import { RichTextEditor } from '@mantine/tiptap';
import CodeBlockLowlight from '@tiptap/extension-code-block-lowlight';
import { useEditor } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import cssLanguageSyntax from 'highlight.js/lib/languages/css';
import { lowlight } from 'lowlight';

lowlight.registerLanguage('css', cssLanguageSyntax);

const CodeBlockExtended = CodeBlockLowlight.extend({
    addKeyboardShortcuts() {
        return {
            Tab: () => {
                this.editor
                    .chain()
                    .command(({ tr }) => {
                        tr.insertText(' ');

                        return true;
                    })
                    .run();

                return true; // <- make sure to return true to prevent the tab from blurring.
            },
        };
    },
});

interface Props {
    onChange: (value: string) => void;
    value: string;
    language: 'css';
}

export default function CodeEditor({ onChange, value, language }: Props) {
    const editor = useEditor({
        extensions: [
            StarterKit,
            CodeBlockExtended.configure({
                lowlight,
            }),
        ],
        content: `<pre><code class="language-${language}">${value || ''}</pre></code>`,
        onUpdate: ({ editor }) => {
            onChange(editor.getText());
        },
    });

    return (
        <RichTextEditor editor={editor}>
            <RichTextEditor.Content />
        </RichTextEditor>
    );
}
